// ═══════════════════════════════════════════════════════════════════════════════
//  ReturnSummary — vista resumen de UNA sola pantalla  [NUEVO — v2]
//  docs/onboarding-master-v2.md, Parte I §7.3
//
//  Para quien ya vio su plan completo y no creó cuenta (`completed_no_signup`).
//  Regla textual del documento:
//    "no reinicia el flujo ni repite las 7 pantallas — lleva directo a una vista
//     resumen de una sola pantalla que reutiliza tal cual el copy ya aprobado de
//     7.2 (a) 'El espejo' y (c) 'El plan', seguida del mismo botón
//     'Quiero mi plan →'. No se repite el arco narrativo completo dos veces."
//
//  Por eso este componente NO trae copy propio: importa exactamente los mismos
//  bloques que Screen7_Revelacion, y muestra solo (a) y (c).
// ═══════════════════════════════════════════════════════════════════════════════

import { getRevelationBlocks, REVELATION_BUTTON } from './onboardingContent';
import { buildLabels } from './onboardingLabels';

export default function ReturnSummary({ payload, onConvert, onRestart }) {
  const labels = buildLabels(payload);

  const blocks = getRevelationBlocks({
    realLevel: labels.realLevel,
    perceivedLabel: labels.perceivedLabel,
    attemptsLabel: labels.attemptsLabel,
    contextLabel: labels.contextLabel,
    feedbackLabel: labels.feedbackLabel,
    aspirationLabel: labels.aspirationLabel,
  });

  // Igual que en Pantalla 7: sin calibración no hay espejo que mostrar.
  const showMirror = Boolean(labels.realLevel);

  return (
    <div className="ob-screen">
      <p className="ob-eyebrow">Aquí seguía tu plan de entrenamiento</p>

      {/* (a) El espejo — copy idéntico al de 7.2 */}
      {showMirror && (
        <div className="ob-reveal-block ob-highlight">
          <p>{blocks.mirror}</p>
        </div>
      )}

      {/* (c) El plan — copy idéntico al de 7.2 */}
      <div className="ob-reveal-block">
        <p>{blocks.plan}</p>
      </div>

      <div className="ob-actions">
        <button type="button" className="ob-btn" onClick={onConvert}>
          {REVELATION_BUTTON}
        </button>
        <button type="button" className="ob-textlink" onClick={onRestart}>
          Prefiero hacer el diagnóstico otra vez
        </button>
      </div>
    </div>
  );
}
